import React from 'react'
import { Row, Col, Form, Input, SelectPicker } from 'rsuite'

const Styles = {
  label: { marginTop: '5px', padding: '8px', textAlign: 'right' },
  input: { marginTop: '5px', padding: '8px' },
}

export default function ExtentionTimePerProjectReportForm({
  schema,
  register,
  Controller,
  control,
}) {
  if (!schema) return null

  return (
    <Form id="mainContainer">
      <Row>
        {schema.budgetYearFrom && (
          <>
            <Col lg={4} md={4} sm={8} xs={8} style={Styles.label}>
              {schema.budgetYearFrom.label}
            </Col>
            <Col lg={8} md={8} sm={16} xs={16} style={Styles.input}>
              <Input
                name="budgetYearFrom"
                inputRef={register()}
                placeholder={`ระบุ${schema.budgetYearFrom.label}`}
                type="number"
              />
            </Col>
          </>
        )}
        {schema.budgetYearTo && (
          <>
            <Col lg={4} md={4} sm={8} xs={8} style={Styles.label}>
              {schema.budgetYearTo.label}
            </Col>
            <Col lg={8} md={8} sm={16} xs={16} style={Styles.input}>
              <Input
                name="budgetYearTo"
                inputRef={register()}
                placeholder={`ระบุ${schema.budgetYearTo.label}`}
                type="number"
              />
            </Col>
          </>
        )}
      </Row>
      <Row>
        {schema.projectCode && (
          <>
            <Col lg={4} md={4} sm={8} xs={8} style={Styles.label}>
              {schema.projectCode.label}
            </Col>
            <Col lg={8} md={8} sm={16} xs={16} style={Styles.input}>
              <Input
                name="projectCode"
                inputRef={register()}
                placeholder={`ระบุ${schema.projectCode.label}`}
              />
            </Col>
          </>
        )}
        {schema.projectName && (
          <>
            <Col lg={4} md={4} sm={8} xs={8} style={Styles.label}>
              {schema.projectName.label}
            </Col>
            <Col lg={8} md={8} sm={16} xs={16} style={Styles.input}>
              <Input
                name="projectName"
                inputRef={register()}
                placeholder={`ระบุ${schema.projectName.label}`}
              />
            </Col>
          </>
        )}
      </Row>
      <Row>
        {schema.department && (
          <>
            <Col lg={4} md={4} sm={8} xs={8} style={Styles.label}>
              {schema.department.label}
            </Col>
            <Col lg={8} md={8} sm={16} xs={16} style={Styles.input}>
              <Controller
                name="department"
                control={control}
                defaultValue={schema.department.optionSelected || null}
                render={(props) => (
                  <SelectPicker
                    data={schema.department.options || []}
                    value={props.value}
                    block
                    placeholder={`เลือก${schema.department.label}`}
                    onChange={props.onChange}
                  />
                )}
              />
            </Col>
          </>
        )}
        <Col lg={4} md={4} sm={8} xs={8} style={Styles.label} />
        <Col lg={8} md={8} sm={16} xs={16} style={Styles.input} />
      </Row>
    </Form>
  )
}
